module.exports = __webpack_public_path__ + "static/media/tool-dev.b283ba73.svg";